module.exports = __webpack_public_path__ + "img/vote-7.edc2d36e.png";